module.exports = __webpack_public_path__ + "static/img/05Hi.3a1dd885.gif";